import fetchAPI from '../fetchAPI';

export const callSignOutCompanyUsers = async (companyId: string): Promise<iResponse<any>> => {
  const response: iResponse<any> = await fetchAPI({
    method: 'POST',
    route: `user/signout-company/${companyId}`
  });
  return response;
};

export default callSignOutCompanyUsers;
